import { render, staticRenderFns } from "./InputTextAreaVariable.vue?vue&type=template&id=7888346c&scoped=true"
import script from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
export * from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
import style0 from "./InputTextAreaVariable.vue?vue&type=style&index=0&id=7888346c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888346c",
  null
  
)

export default component.exports